import React from 'react';
import Text from 'Components/Text';
import Button, { buttonColor } from 'Components/Button';
import { STEP_ID } from 'constants/boatApplication';

export default class BoatInfo extends React.Component {
  render() {
    const { boatSpecifications, isFinalReview, goToStep, boatDetailsRequestInProcess } = this.props;

    if (boatDetailsRequestInProcess) return null;

    if (boatSpecifications === undefined) return null;

    return (
      <section className='scene_section'>
        <header>Boat info</header>
        <Text
          mainWrapperClassName='text__wrapper_primary _margin_right_30'
          textClassName='text__text_primary'
          label='Boat Name'
          value={boatSpecifications.name}
        />
        <Text
          mainWrapperClassName='text__wrapper_primary'
          textClassName='text__text_primary'
          label='Model Year'
          value={boatSpecifications.year}
        />
        <Text
          mainWrapperClassName='text__wrapper_primary _width_pc_100'
          textClassName='text__text_primary'
          label='Manufacturer Plant'
          value={boatSpecifications.cityAndStateForCapacityTag}
        />
        {isFinalReview && (
          <Button
            color={buttonColor.planeOrange}
            label='Edit'
            buttonClassName='_height_20 _width_60 _position_absolute _right_130 _font_size_14'
            fontSize={14}
            onClick={() => goToStep(STEP_ID.BOAT_SPECIFICATIONS, true)}
          />
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/BoatInfo.jsx